import { Instance, applySnapshot, types } from 'mobx-state-tree';

const AppliedCoupon = types.model('AppliedCoupon', {
  discountPercentage: types.maybeNull(types.number),
  discountAmount: types.maybeNull(types.number),
  code: types.string,
});

const CouponFormModel = types
  .model('CouponForm', {
    showCouponInput: types.optional(types.boolean, false),
    couponCodeText: types.optional(types.string, ''),
    appliedCoupon: types.maybeNull(AppliedCoupon),
  })
  .actions((self) => ({
    setShowCouponInput(value: boolean) {
      self.showCouponInput = value;
    },
    setCouponCodeText(value: string) {
      self.couponCodeText = value;
    },
    setAppliedCoupon(appliedCoupon: AppliedCouponInstance | null) {
      applySnapshot(self, {
        ...self,
        appliedCoupon: appliedCoupon,
      });
    },
  }));

export const PaymentComponentMetadata = types
  .model('PaymentComponentMetadata', {
    showMobilePaymentSummary: types.optional(types.boolean, false),
    couponForm: CouponFormModel,
  })
  .actions((self) => ({
    toggleShowMobilePaymentSummary() {
      self.showMobilePaymentSummary = !self.showMobilePaymentSummary;
    },
    ShowMobilePaymentSummary() {
      self.showMobilePaymentSummary = true;
    },
  }));

interface AppliedCouponInstance extends Instance<typeof AppliedCoupon> {}
